import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'app/modules/auth/services/auth.service';
import { SharedService } from '../services/shared-service';
import Utils from 'app/Utils';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private sharedService: SharedService,
    private authService: AuthService) { }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    // handle your auth error or rethrow
    if (err.status === 401 || err.status === 403) {
      this.authService.logout();
      // this.sharedService.ShowSnackBar('la sesión actual ha expirado, inicie sesión de nuevo para continuar', 'okay', 2000);
      return of('');
    }
    return throwError(err);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) 
    if (currentUser && currentUser.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`
        }
      });
    }

    return next.handle(request).pipe(catchError(x => this.handleAuthError(x)));
  }

}
